import {isEmpty} from "./helpers";

/**
 * Google Tag Manager Custom Event Trigger for contact
 * @param isOnList {boolean}
 * */

export function ContactEvents(isOnList = false) {
    if (!isEmpty(window.dataLayer)) {
        window.dataLayer.push({
            'event': isOnList ? 'on_properties_user_contact' : 'user_contact',
        });
    }
}

/**
 * Google Tag Manager Custom Event
 * @param event {String}
 * */

export function GoogleTagManagerEvent(event) {
    if (!isEmpty(window.dataLayer)) {
        window.dataLayer.push({
            'event': event,
        });
    }
}